import React from 'react'
import AddBanBreadCrumb from './AddBanBreadCrumb';
import AddNewBanners from './AddNewBanner';
function AddBannersPage() {
    return ( 
        <div className="container-fluid">
            <AddBanBreadCrumb />
            <AddNewBanners />
        </div>
     );
}

export default AddBannersPage;